import { render, staticRenderFns } from "./curveController.vue?vue&type=template&id=b42288e4&"
import script from "./curveController.vue?vue&type=script&lang=ts&"
export * from "./curveController.vue?vue&type=script&lang=ts&"
import style0 from "./curveController.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports